export enum PromotionItemRestrictionEnum {
  GROUPID = 'groupUID',
  STARTTIME = 'startTime',
  ENDTIME = 'endTime',
}
